export const ConsumerEmailViewUat = {
  sendCopy: 'consumerEmail.sendCopy',
  askEmail: 'consumerEmail.askEmail'
}
